import { useState } from 'react';
import { comments } from '@/mocks/homeData';
import SectionHeading from './SectionHeading';

const toneMap: Record<string, string> = {
  primary: 'bg-primary-500 text-background-50',
  accent: 'bg-accent-500 text-background-50',
  secondary: 'bg-secondary-500 text-background-50',
};

export default function CommentWall() {
  const [liked, setLiked] = useState<Record<string, boolean>>({});
  const [draft, setDraft] = useState('');
  const [toast, setToast] = useState('');

  const toggleLike = (id: string) => {
    setLiked((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const likeCount = (id: string, base: number) => (liked[id] ? base + 1 : base);

  const submitDraft = () => {
    if (!draft.trim()) {
      setToast('先写两句再发布哦');
    } else {
      setToast('演示页面：留言不会真正提交');
    }
    setDraft('');
    window.setTimeout(() => setToast(''), 2200);
  };

  return (
    <section className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <SectionHeading
            eyebrow="用户留言墙"
            title="大家的使用反馈，都在这儿"
            desc="留言墙记录真实使用感受，正面评价和踩坑经验都会保留，方便后来的人少走弯路。"
          />
          <div className="flex items-center gap-4 text-sm text-foreground-600">
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-chat-3-line text-primary-600 text-lg"></i>
              {comments.length} 条留言
            </span>
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-thumb-up-line text-accent-600 text-lg"></i>
              互动热度较高
            </span>
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="lg:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-4">
            {comments.map((c) => (
              <article key={c.id} className="bg-background-50 border border-background-200 rounded-lg p-4 md:p-5 flex flex-col">
                <div className="flex items-center gap-3">
                  <span className={`w-10 h-10 rounded-full flex items-center justify-center font-heading ${toneMap[c.tone]}`}>
                    {c.initial}
                  </span>
                  <div>
                    <div className="text-sm text-foreground-950">{c.name}</div>
                    <div className="text-xs text-foreground-500">{c.time}</div>
                  </div>
                </div>
                <p className="mt-3 text-sm text-foreground-700 leading-relaxed flex-1">{c.text}</p>
                <div className="mt-4 pt-3 border-t border-background-200 flex items-center justify-between">
                  <button
                    type="button"
                    onClick={() => toggleLike(c.id)}
                    className={`inline-flex items-center gap-1.5 text-xs cursor-pointer transition-colors ${
                      liked[c.id] ? 'text-primary-700' : 'text-foreground-500 hover:text-primary-700'
                    }`}
                  >
                    <i className={liked[c.id] ? 'ri-thumb-up-fill' : 'ri-thumb-up-line'}></i>
                    {likeCount(c.id, c.likes)}
                  </button>
                  <span className="inline-flex items-center gap-1.5 text-xs text-foreground-400">
                    <i className="ri-chat-1-line"></i>
                    回复
                  </span>
                </div>
              </article>
            ))}
          </div>

          <aside className="bg-background-50 border border-background-200 rounded-lg p-5 flex flex-col">
            <div className="flex items-center gap-2 text-foreground-950">
              <i className="ri-edit-2-line text-primary-600 text-lg"></i>
              <span className="font-heading text-lg tracking-wide">写下你的使用感受</span>
            </div>
            <p className="mt-2 text-xs text-foreground-500">演示态留言，内容不会真正提交。</p>
            <textarea
              value={draft}
              maxLength={200}
              onChange={(e) => setDraft(e.target.value)}
              placeholder="说说你是怎么用黑料导航的，或者遇到了什么问题…"
              className="mt-3 flex-1 min-h-[140px] w-full rounded-md border border-background-200 bg-background-50 p-3 text-sm text-foreground-950 outline-none resize-none focus:border-primary-400 placeholder:text-foreground-400"
            />
            <div className="mt-3 flex items-center justify-between">
              <span className="text-xs text-foreground-400">{draft.length}/200</span>
              <button
                type="button"
                onClick={submitDraft}
                className="inline-flex items-center gap-1.5 px-5 py-2 rounded-md bg-primary-500 text-background-50 text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-send-plane-line"></i>
                发布留言
              </button>
            </div>
            {toast && (
              <div className="mt-3 px-3 py-2 rounded-md bg-secondary-100 text-secondary-900 text-xs">{toast}</div>
            )}
          </aside>
        </div>
      </div>
    </section>
  );
}